import React, { createContext, useState, useContext } from "react";

const SendStationContext = createContext();

export const useSendStation = () => useContext(SendStationContext);

export const SendStationProvider = ({ children }) => {
  const [currentStation, setCurrentStation] = useState(null);
  const [sendEmailModalOpen, setSendEmailModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [emailEditable, setEmailEditable] = useState(true);
  const [reportFormat, setReportFormat] = useState("pdf");

  const isEmailValid = /^\S+@\S+\.\S+$/.test(email);

  return (
    <SendStationContext.Provider
      value={{
        currentStation,
        setCurrentStation,
        email,
        setEmail,
        emailEditable,
        setEmailEditable,
        reportFormat,
        setReportFormat,
        sendEmailModalOpen,
        setSendEmailModalOpen,
        isEmailValid,
      }}
    >
      {children}
    </SendStationContext.Provider>
  );
};
